import React from "react";
import Skeleton from "react-loading-skeleton";

function PrProfileCardSkeleton() {
  return (
    <div className="card h-100 pr-user-card skeleton-card animated faster fadeIn">
      <div className="card-body d-flex flex-column">
        <div className="text-center mb-2">
          <Skeleton height={128} width="90%" />
        </div>

        <div className="mb-2">
          <Skeleton height={15} width="100%" />
          <div className="card-grid-subtitle smaller">
            <Skeleton height={12} width="30%" />
            <Skeleton height={12} width="15%" />
          </div>
        </div>

        <div className="smaller mb-2">
          <Skeleton height={12} width="45%" />
          <Skeleton height={12} width="35%" />
        </div>

        <div className="smallest mb-2">
          <Skeleton height={8} width="25%" />
          <Skeleton height={8} width="35%" />
          <Skeleton height={8} width="15%" />
        </div>

        <div className="mt-auto text-center">
          <Skeleton height={25} width="60%" />
        </div>
      </div>
    </div>
  );
}

export default PrProfileCardSkeleton;
